module.exports = __webpack_public_path__ + "img/pic18.04884ff2.jpg";